import { Dimensions, StyleSheet } from 'react-native';
import theme from '../../../common/theme';

const styles = StyleSheet.create({
  container: {
    width: 240,
    backgroundColor: theme.palette.white,
  },
  // eslint-disable-next-line react-native/no-color-literals
  button: {
    width: 44,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.radius.m,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    position: 'absolute',
    top: 16,
    right: 16,
  },
  marker: {
    position: 'absolute',
    top: 6,
    right: 6,
    width: 12,
    height: 12,
    borderRadius: 10,
    backgroundColor: theme.palette.green,
    zIndex: 1,
  },
  optionsBg: {
    padding: 10,
    paddingBottom: 0,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.white,
    ...theme.shadow.light,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 10,
    marginBottom: 10,
  },
  text: {
    flex: 1,
    fontSize: 14,
    lineHeight: 20,
    fontFamily: theme.fonts.medium,
    color: theme.palette.mono800,
  },
  textNegative: {
    color: theme.palette.red,
  },
  textNeutral: {
    color: theme.palette.blue,
  },
  icon: {
    width: 38,
    height: 38,
    alignItems: 'center',
    justifyContent: 'center',
  },
  bgStyle: {
    width: '100%',
    height: Dimensions.get('window').height,
    position: 'absolute',
  },
  optionsContainer: {
    width: 260,
    maxWidth: 260,
    backgroundColor: theme.palette.white,
    borderRadius: theme.radius.s,
    marginBottom: 10,
  },
  arrowStyle: {
    backgroundColor: theme.palette.white,
  },
});

export default styles;
